import {getConfigSettings, getSettingsFieldsDefinition} from '@pazion/pazion-core/src/services/base-service';
import {addChildRoute, removeChildRoute, removeRouteByName, resetRouter} from '@pazion/pazion-core/src/router';
import _Vue from 'vue';

import PlaceholderSettingsPage from "@pazion/pazion-core/src/views/settings/SettingsPage.vue"
import {IProjectSettings, setConfigLocal} from '@pazion/pazion-core/src/models/config_variables';
import {IS_PRODUCTION} from "@pazion/pazion-core/src/config";
import store, {authentication, permission, settings} from "@pazion/pazion-core/src/store";


async function setProtoVariables(settings: IProjectSettings, Vue: typeof _Vue) {

    if (settings && 'config' in settings) {

        //TODO: DEPRECATED

        for (let option in settings.config) {
            Vue.prototype[`$${option}`] = settings.config[option]
        }
        for (let option in settings.featureFlags) {
            Vue.prototype[`$${option}`] = settings.featureFlags[option];
        }

        //NOTE: SPECIAL SETTINGS FOR PRODICTIONS
        if (IS_PRODUCTION && !('VUE_APP_BACKEND_API_ROOT' in process.env)) {
            authentication.updateBaseUrl(settings.base['url']);
            authentication.updateApiUrl(settings.base['apiUrl']);
        }


        deleteRoutersPerSettings(settings);

        Vue.prototype.apiPackage = {};
        for (let option in settings.apiPackage) {
            Vue.prototype.apiPackage[`$${option}`] = settings.apiPackage[option]
        }
        addApiPackageSettings(settings);

    }
}

async function deleteRoutersPerSettings(settings: IProjectSettings) {

    const featureFlags = settings.featureFlags;

    if (!featureFlags)
        return

    /*
    * TODO: DEPRECATED: Will get from  permission.getfeatureFlags
    */
    if (featureFlags.stockManagement != true)
        removeRouteByName('stock');

    if (featureFlags.productManagement != true)
        removeRouteByName('products');

    if (featureFlags.dossierManagement != true)
        removeRouteByName('dossier');

    if (featureFlags.accountManagement != true)
        removeRouteByName('accounts');

    if (featureFlags.invoiceManagement != true)
        removeRouteByName('invoices');

    if (featureFlags.orderManagement != true)
        removeRouteByName('orders');

    if (featureFlags.contractManagement != true)
        removeRouteByName('contracts');

    if (featureFlags.transactionManagement != true)
        removeRouteByName('transactions');

    if (featureFlags.productionManagement != true)
        removeRouteByName('productions');

    if (featureFlags.offerManagement != true)
        removeRouteByName('offers');

    if (featureFlags.returnManagement != true)
        removeRouteByName("returns");

    if (featureFlags.logManagement != true)
        removeChildRoute('settings', 'logs');

    if (featureFlags.queueManagement != true)
        removeChildRoute('settings', 'queue');

    if (featureFlags.membersCardManagement != true)
        removeRouteByName('cards');

    if (featureFlags.membersCardManagement != true)
        removeRouteByName('card members');

    if (featureFlags.membersCardManagement != true)
        removeRouteByName('card design');

    if (featureFlags.groupManagement != true) {
        removeChildRoute('settings', 'group')
    }
    if (featureFlags.requiredDocumentManagement != true) {
        removeChildRoute('settings', 'document-categories');
        removeChildRoute('settings', 'required-documents');
    }

    if (featureFlags.fulfilmentManagement != true) {
        removeRouteByName('shipments')
    }

    if (featureFlags.packageSettings != true) {
        removeChildRoute('settings', 'packages');
        removeChildRoute('settings', 'package-edit');
    }

    //rewrite our route array
    resetRouter();
}

/** should be phased out now we have frontend package config */
function addApiPackageSettings(settings: IProjectSettings) {

    const apiPackages = settings.apiPackage;

    if (!apiPackages)
        return

    if (apiPackages.dynamicsSettings == true) {


        if (apiPackages.dynamicsSettings == true) {
            addChildRoute("settings", {
                path: "dynamics/settings",
                name: "dynamics",
                component: PlaceholderSettingsPage,
                meta: {
                    "show-in-nav": true,
                    "redirect-to-backend": true,
                    profilePermission: 'packageManagement.show',
                    roles: ["user"]
                }
            });
        }

        if (apiPackages.bumbalSettings == true) {
            addChildRoute("settings", {
                path: "bumbal/settings",
                name: "bumbal",
                component: PlaceholderSettingsPage,
                meta: {
                    "show-in-nav": true,
                    profilePermission: 'packageManagement.show',
                    "redirect-to-backend": true,
                    roles: ["user"]
                }
            });
        }
        if (apiPackages.postnlSettings == true) {
            addChildRoute("settings", {
                path: "postnl/settings",
                name: "postnl",
                component: PlaceholderSettingsPage,
                meta: {
                    "show-in-nav": true,
                    "redirect-to-backend": true,
                    profilePermission: 'packageManagement.show',
                    roles: ["user"],
                    sort: 800
                }
            });
        }
        if (apiPackages.devPackage == true) {
            addChildRoute("settings", {
                path: "dev/doc",
                name: "docs",
                component: PlaceholderSettingsPage,
                meta: {
                    "icon": 'mdi-book-open-page-variant',
                    "show-in-nav": true,
                    profilePermission: 'packageManagement.show',
                    "redirect-to-backend": true,
                    roles: ["user"],
                    sort: 900
                }
            });
        }
    }

}


export async function setConfigSettings(Vue: typeof _Vue): Promise<void> {
    setConfigLocal(Vue)
    //NOTE: GET from store and check
    const storeSettings = store.getters.getFeatureFlag
    if (storeSettings) {
        setProtoVariables(JSON.parse(storeSettings), Vue);
        return
    } else {
        const serverSettings = await getConfigSettings();
        const feildsDefinition = await getSettingsFieldsDefinition();
        permission.updatePermissons(serverSettings);
        settings.getSettingsFieldsDefinition(feildsDefinition);
        setProtoVariables(serverSettings, Vue);
        ;
    }
};

